import { useEffect } from 'react';
import { IconX } from '@tabler/icons-react';
import ReactModal from 'react-modal';

ReactModal.setAppElement('#root');

function AppModal({
  isOpen,
  onClose,
  title,
  children,
  size = 'lg',
  className = '',
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    function onKeyDown(event) {
      if (event.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      closeTimeoutMS={120}
      overlayClassName="app-modal-overlay"
      className={`app-modal app-modal-${size} ${className}`.trim()}
      contentLabel={title || 'Modal'}
    >
      <header className="app-modal-header">
        <h3>{title || 'Details'}</h3>
        <button type="button" className="icon-button" onClick={onClose} aria-label="Close modal">
          <IconX size={18} />
        </button>
      </header>
      <div className="app-modal-body">{children}</div>
    </ReactModal>
  );
}

export default AppModal;
